import { useCallback, useEffect, useMemo, useState } from "react";
import { io } from "socket.io-client";
import { SOCKET_URL } from "../../services/api";
export const useSocket = (globalSearch) => {
  const [livestreams, setLivestreams] = useState([]);

  // ---------- Connect Socket at Once -------------
  const socket = useMemo(() => {
    return io(`${SOCKET_URL}`, {
      query: { token: localStorage.getItem("token") },
    });
  }, []);

  // --------- Use Effect ----------------
  useEffect(() => {
    socket.on("connect", () => {
      console.log("socket connected....");
    });
    const payload = { lang: "en" };
    if (globalSearch !== "") {
      payload.search = globalSearch;
    }
    socket.on("validation_response", (res) => {
      if (res.status === true) {
        socket.emit("livestream:list", payload);
        socket.on("livestream:list", (res) => {
          if (res.status === true) {
            setLivestreams(res.data);
          }
        });
      }
    });

    // return () => {
    //   socket.disconnect("disconnect", () => {
    //     console.log("socket disconnected....");
    //   });
    // };

    return () => {
      socket.removeAllListeners();
      socket.disconnect();
      console.log("socket disconnected....");
    };
  }, [globalSearch]);
  return livestreams;
};
export const useSocketPlayStream = (id) => {
  const [viewers, setViewers] = useState([]);
  const [history, setHistory] = useState([]);
  const [streamPlayers, setStreamPlayers] = useState([]);

  // Create socket only once
  const socket = useMemo(() => {
    return io(`http://103.189.173.7:3369`, {
      query: { token: localStorage.getItem("token") },
    });
  }, [id]);

  useEffect(() => {
    if (!id) return;
    socket.on("connect", () => {
      console.log("socket connected ....");
    });

    socket.emit("livestream:join", { streamId: id });

    socket.on("livestream:viewers", (res) => {
      setViewers(res.viewers);
    });

    socket.on("livestream:history", (res) => {
      setStreamPlayers(res.players);
      setHistory(res.messages);
    });

    // Listen for new incoming messages in real-time and append to history
    socket.on("livestream:message", (res) => {
      if (!res) return;
      if (res.streamId && res.streamId !== id) return;
      // Some servers may send a single message object or a wrapped payload
      const incoming = Array.isArray(res.messages)
        ? res.messages
        : Array.isArray(res)
          ? res
          : [res.message || res];
      setHistory((prev) => [...prev, ...incoming]);
    });

    // Cleanup on unmount
    return () => {
      socket.off("livestream:viewers");
      socket.off("livestream:history");
      socket.off("livestream:message");
      socket.disconnect();
    };
  }, [id, socket]);

  return { viewers, history, streamPlayers };
};

export const usePushComment = () => {
  const socket = useMemo(() => {
    return io("http://103.189.173.7:3369", {
      query: { token: localStorage.getItem("token") },
    });
  }, []);

  socket.on("connect", () => {
    console.log("socket connected for comments ....");
  });

  // Return a function to send comments
  const pushComment = useCallback(
    (data) => {
      if (!data) return;
      socket.emit("livestream:message", {
        streamId: data.id,
        message: data.comment,
      });
    },
    [socket],
  );

  // Optional: cleanup
  useMemo(() => () => socket.disconnect(), [socket]);

  return pushComment;
};
